import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useGetUsersQuery, useProfileMutation } from '../../slices/usersApiSlice';

const AdminProfileScreen = () => {
  const navigate = useNavigate();

  // Fetch users
  const { data: users, isLoading, error, refetch } = useGetUsersQuery();
  const [updateProfile, { isLoading: loadingUpdate }] = useProfileMutation();

  // State management
  const [selectedUser, setSelectedUser] = useState('');
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  // Load user details when selected
  useEffect(() => {
    if (selectedUser) {
      const user = users?.find((u) => u._id === selectedUser);
      if (user) {
        setName(user.name);
        setUsername(user.username);
        setPassword(password);
        setEmail(user.email);
        setIsAdmin(user.isAdmin);
      }
    }
  }, [selectedUser, users]);

  // Handle form submission with password update
  const submitHandler = async (e) => {
    e.preventDefault();

    if (!selectedUser) {
      toast.error('Please select a user');
      return;
    }

    if (password && password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (!window.confirm('Are you sure you want to update this user?')) {
      return;
    }

    try {
      
      await updateProfile({
        userId: selectedUser,
        
        password, // ✅ Password field included for reset
      
      }).unwrap();
      
      toast.success('User updated successfully');
      refetch();
      navigate('/admin/userlist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <Row>
      <Col md={6}>
        <h2>Admin: Update User Profile</h2>

        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error?.data?.message || error.error}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group className="my-2" controlId="user">
              <Form.Label>Select User</Form.Label>
              <Form.Control
                as="select"
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                <option value="">-- Select a User --</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name} ({user.email})
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="my-2" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="username">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="email">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="isadmin">
              <Form.Check
                type="checkbox"
                label="Is Admin"
                checked={isAdmin}
                onChange={(e) => setIsAdmin(e.target.checked)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="password">
              <Form.Label>New Password (optional)</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="my-2" controlId="confirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>

            <Button type="submit" variant="primary" disabled={!selectedUser}>
              Update Profile
            </Button>
            {loadingUpdate && <Loader />}
          </Form>
        )}
      </Col>
    </Row>
  );
};

export default AdminProfileScreen;